// extracted by mini-css-extract-plugin
export var container = "styles-module--container--dRBMQ";
export var imagePart = "styles-module--imagePart--tdm0S";
export var name = "styles-module--name--9yaEo";
export var subline = "styles-module--subline--tuk3K";
export var dutyList = "styles-module--dutyList--bW2q2";
export var contactList = "styles-module--contactList--sHF62";
export var contactListItemLabel = "styles-module--contactListItemLabel--3bGVk";